<form
  [formGroup]="formGroup"
  (ngSubmit)="submit()"
  autocomplete="off"
  class="entry-form"
>
  <box class="field-set">

    <app-TransactionPeriodList
      class="col-sm-12 col-lg-12 col-md-12"
      label="{{
        'CASATRANSACTIONFILTERFORM.transactionPeriod_lbl' | translate
      }}"
      placeholder="{{
        'CASATRANSACTIONFILTERFORM.transactionPeriod_placeholder' | translate
      }}"
      formControlName="transactionPeriod"
    ></app-TransactionPeriodList>

    <ng-container *ngIf="_responsive.isMobile()">
      <ng-container *ngIf="state.ismonthOrDate == 'MONTH'">
      <div class="yearmonthbx">
      <div  class="year-set">
        <div class="col-sm-12 col-lg-12 col-md-12">
        <app-yearlist
          label="{{ 'CASATRANSACTIONFILTERFORM.year_lbl' | translate }}"
          placeholder="{{
            'CASATRANSACTIONFILTERFORM.year_placeholder' | translate
          }}"
          formControlName="year"
          ngModel

        ></app-yearlist>
      </div></div>
      <div class="date-container">
        <div class="month-set" class="col-sm-12 col-lg-12 col-md-12">
          <app-MonthFlagList
            label="{{ 'CASATRANSACTIONFILTERFORM.month_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.month_placeholder' | translate
            }}"
            formControlName="month"
			      [changePublisher]="formChangePublisher$"
            [dependencyField]="['year']"
            ngModel

          ></app-MonthFlagList>
        </div>
      
      </div>
    </div>  
    </ng-container>
    </ng-container>
    <ng-container *ngIf="!_responsive.isMobile()">
      <div class="date-container" *ngIf="state.ismonthOrDate == 'MONTH'">
      
        <div class="year-set" >
          <app-yearlist class="col-sm-12 col-lg-12 col-md-12"
            label="{{ 'CASATRANSACTIONFILTERFORM.year_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.year_placeholder' | translate
            }}"
            formControlName="year"
            ngModel

          ></app-yearlist>
        </div>

        <div class="month-set">
          <app-MonthFlagList  class="col-sm-12 col-lg-12 col-md-12"
            label="{{ 'CASATRANSACTIONFILTERFORM.month_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.month_placeholder' | translate
            }}"
            formControlName="month"
            ngModel
            [changePublisher]="formChangePublisher$"
            [dependencyField]="['year']"
          ></app-MonthFlagList>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="_responsive.isMobile()">
      <div class="select-date" *ngIf="state.ismonthOrDate == 'DATE'">
        <div class="from-set">
          <app-request-date-control
            class="col-sm-12 col-lg-6 col-md-12"
            label="{{ 'CASATRANSACTIONFILTERFORM.from_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.from_placeholder' | translate
            }}"
            formControlName="from"
            [minDate]="state.fromMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
        <div class="to-set">
          <app-request-date-control
            class="col-sm-12 col-lg-6 col-md-12"
            label="{{ 'CASATRANSACTIONFILTERFORM.to_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.to_placeholder' | translate
            }}"
            formControlName="to"
            [minDate]="state.toMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!_responsive.isMobile()">
      <div class="select-date" *ngIf="state.ismonthOrDate == 'DATE'">
        <div class="from-set">
          <app-request-date-control
            class="col-sm-12 col-lg-12 col-md-12"
            label="{{ 'CASATRANSACTIONFILTERFORM.from_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.from_placeholder' | translate
            }}"
            formControlName="from"
            [minDate]="state.fromMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
        <div class="to-set">
          <app-request-date-control
            class="col-sm-12 col-lg-12 col-md-12"
            label="{{ 'CASATRANSACTIONFILTERFORM.to_lbl' | translate }}"
            placeholder="{{
              'CASATRANSACTIONFILTERFORM.to_placeholder' | translate
            }}"
            formControlName="to"
            [minDate]="state.toMinDate"
            [maxDate]="state.maxDate"
            ngModel

          ></app-request-date-control>
        </div>
      </div>
    </ng-container>
    <app-DisDownformatlist
      class="col-sm-12 col-lg-12 col-md-12"
      label="{{
        'CASATRANSACTIONFILTERFORM.displayDownloadFormat_lbl' | translate
      }}"
      placeholder="{{
        'CASATRANSACTIONFILTERFORM.displayDownloadFormat_placeholder'
          | translate
      }}"
      formControlName="displayDownloadFormat"
    ></app-DisDownformatlist>
  </box>

  <ng-container *ngIf="_responsive.isMobile()">
    <div class="filter-form-btn">
      <box class="filter-form-btn-grp2">
        <button
          *ngIf="formGroup"
          type="button"
          (click)="_helper.submitForm()"
          class="button-common button40 active"
          [disabled]="!formGroup.valid || state.isDateValid"
        >
          <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
        </button>
      </box>
      <box class="filter-form-btn-grp1">
        <button
          type="button"
          class="btn-link"
          [ngClass]="{
            'btn-visibility-hidden': !state.showReset
          }"
          (click)="cASATransactionFilterFormHelper.reset()"
        >
          <span class="reset-btn">Reset</span>
        </button>
      </box>
    </div>
  </ng-container>
</form>
<ng-container *ngIf="!_responsive.isMobile()">
  <div class="filter-form-btn">
    <box class="filter-form-btn-grp2">
      <button
        type="button"
        class="btn-link"
        [ngClass]="{
          'btn-visibility-hidden': !state.showReset
        }"
        (click)="cASATransactionFilterFormHelper.reset()"
      >
        <span class="reset-btn">Reset</span>
      </button>
      <button
        *ngIf="formGroup"
        type="button"
        (click)="_helper.submitForm()"
        class="button-common button40 active"
        [disabled]="!formGroup.valid || state.isDateValid"
      >
        <span>{{ mode == "MODIFY" ? "Update" : "Submit" }}</span>
      </button>
    </box>
  </div>
</ng-container>
